const topics = [
  { name: '台北娜娜', hot: true, count: '12.8万' },
  { name: '玩偶姐姐', hot: true, count: '9.6万' },
  { name: '莫里秀', hot: true, count: '7.3万' },
  { name: '直播翻车', hot: false, count: '6.1万' },
  { name: '吃瓜短视频', hot: true, count: '15.2万' },
  { name: '网红热梗', hot: false, count: '5.4万' },
  { name: '吃瓜娱乐', hot: true, count: '8.9万' },
  { name: '真人秀片段', hot: false, count: '4.7万' },
  { name: '搞笑吃瓜', hot: false, count: '11.3万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          大家都在搜的热门吃瓜话题，热度实时更新
        </p>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((t, i) => (
            <div
              key={i}
              className="group flex items-center gap-2.5 px-4 md:px-5 py-2.5 md:py-3 bg-background-50 rounded-full border border-background-200/80 hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
            >
              {t.hot && (
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{t.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{t.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}